import { type ICellRendererParams } from "ag-grid-enterprise";

import { BTUser } from "commonComponents/btWrappers/BTUser/BTUser";

export interface IColumnUserParams<TData> {
    getUserId: (params: ICellRendererParams<TData>) => number | null | undefined;
    getDisplayName: (params: ICellRendererParams<TData>) => string | null | undefined;
    boldCurrentUser?: boolean;
}

export function columnUser<TData>(params: ICellRendererParams<TData> & IColumnUserParams<TData>) {
    if (!params.data) return null;

    const userId = params.getUserId(params);

    if (!userId) return null;

    const displayName = params.getDisplayName(params) ?? "Unknown user";

    return (
        <BTUser
            globalUserId={userId}
            displayName={displayName}
            type="full"
            size="small"
            contactCard="hover"
            data-testid="column-user"
            boldCurrentUser={params.boldCurrentUser}
        />
    );
}
